"use client"

import { useEffect, useState } from 'react'

/**
 * true если приложение запущено в standalone-режиме PWA
 * (установлено на home screen, без браузерного UI)
 */
export function useIsStandalone(): boolean {
  const [isStandalone, setIsStandalone] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined') return

    const check = () => {
      // Chrome / Android / Desktop PWA
      const mql = window.matchMedia('(display-mode: standalone)').matches
      // iOS Safari — не поддерживает display-mode, использует свой флаг
      const iosStandalone = (window.navigator as any).standalone === true
      setIsStandalone(mql || iosStandalone)
    }

    check()

    // Реагируем на смену режима (редко, но бывает — devtools, установка/удаление)
    const mql = window.matchMedia('(display-mode: standalone)')
    mql.addEventListener('change', check)
    return () => mql.removeEventListener('change', check)
  }, [])

  return isStandalone
}